const hasStructuredClone = typeof structuredClone === "function";

export const createDefaultQuizState = () => ({
  topicId: null,
  questions: [],
  goalDetails: {},
  currentQuestionIndex: 0,
  selectedOption: null,
  score: 0,
  showExplanation: false,
  quizCompleted: false,
  leveledUp: false,
  goalStatus: "",
  userAnswers: [],
  descriptiveAnswers: [],
  descriptiveUploads: [],
});

const shallowCloneUploads = (uploads) => {
  if (!Array.isArray(uploads)) return [];
  return uploads.map((entry) => {
    if (Array.isArray(entry)) {
      return [...entry];
    }
    return entry;
  });
};

const cloneQuizState = (state) => {
  if (!state || typeof state !== "object") {
    return createDefaultQuizState();
  }

  if (hasStructuredClone) {
    try {
      return structuredClone(state);
    } catch (error) {
      console.warn("structuredClone failed for quiz state, falling back", error);
    }
  }

  return {
    topicId: state.topicId ?? null,
    questions: state.questions ?? [],
    goalDetails: state.goalDetails ?? {},
    currentQuestionIndex:
      typeof state.currentQuestionIndex === "number"
        ? state.currentQuestionIndex
        : 0,
    selectedOption:
      typeof state.selectedOption === "number" ? state.selectedOption : null,
    score: Number.isFinite(state.score) ? state.score : 0,
    showExplanation: Boolean(state.showExplanation),
    quizCompleted: Boolean(state.quizCompleted),
    leveledUp: Boolean(state.leveledUp),
    goalStatus: state.goalStatus ?? "",
    userAnswers: Array.isArray(state.userAnswers)
      ? [...state.userAnswers]
      : [],
    descriptiveAnswers: Array.isArray(state.descriptiveAnswers)
      ? [...state.descriptiveAnswers]
      : [],
    descriptiveUploads: shallowCloneUploads(state.descriptiveUploads),
  };
};

export const persistQuizStateToWindow = (state) => {
  if (typeof window === "undefined") return;
  window.__quizState = cloneQuizState(state);
};

export const getStoredQuizState = () => {
  if (typeof window !== "undefined" && window.__quizState) {
    return cloneQuizState(window.__quizState);
  }
  return createDefaultQuizState();
};

export const clearQuizStateFromWindow = () => {
  persistQuizStateToWindow(createDefaultQuizState());
};
